/* eslint-disable array-callback-return */
import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import myLeadsState from 'Stores/myLeads';
import { createNewListState } from 'Components/common/createNewList';
import { confirmationPopupState } from 'Components/common/confirmationPopup';
import Dropdown from 'Components/common/dropdown';
import { ReactComponent as LeftArrowIcon } from 'Assets/svg/left-arrow-thicker.svg';
import { ReactComponent as ThreeDotsIcon } from 'Assets/usageAnalytics/three-dots-icon.svg';
import { ReactComponent as ArchivedIcon } from 'Assets/svg/archive-icon.svg';
import { ReactComponent as InfoIcon } from 'Assets/svg/info-icon.svg';
import archivedCountInfoImg from 'Assets/png/archived-count-info.png';
import userDetail from 'Stores/userDetail';
import { Utils } from 'Utils/utils';
import InfoDropDownWithImg from 'Components/common/InfoDropDownWithImg';
import SharedListIcon from 'Components/common/SharedListIcon';

const ListPageHeader = observer(props => {
  const { list = {}, history } = props;
  const { archivedCount = 0 } = list;
  const renameLeadsList = e => {
    createNewListState.setActionMethod('update');
    createNewListState.setDefaultValue(list.name);
    createNewListState.setDefaultListId(list.id);
    createNewListState.setShowCreateList(true);
  };

  const deleteLeadsList = e => {
    const callback = async () => {
      const isSuccess = await myLeadsState.deleteLeadsList(list.id, list.name);
      if (isSuccess) history.push('/my-leads');
    };
    confirmationPopupState.setPopupValues({
      title: 'Delete List',
      content: `<div>Are you sure you want to delete the List <b>“${list.name}”</b>? </br></div> <div>All the contacts in this list will still be available in 'All Leads'</div>`,
      actionBtnText: 'Delete',
      customClassName: 'my-leads-action-popup delete-list-popup',
      callback,
    });
    confirmationPopupState.setShowPopup(true);
  };

  const description = (
    <>
      We have archived the older contacts in your list. Please write to{' '}
      <a href="mailto:support@adapt.io">support@adapt.io</a>, if you want to
      access the archived contacts
    </>
  );

  return (
    <div className="left-section my-leads-content list-page-header">
      <div className="leads-container ">
        <div className="leads-list-header my-leads-header">
          <div className="wrapper">
            <a
              onClick={e => {
                e.preventDefault();
                history.goBack();
              }}
              href="/my-leads"
            >
              <LeftArrowIcon className="lead-name-left-arrow" />
            </a>
            <span
              className={`leads-header${
                userDetail.myLeadListLoaded ? '' : ' linear-background'
              }`}
            >
              {list.name}
            </span>
            <SharedListIcon data={list} />
            {list.name !== 'All Leads' &&
              list.name !== 'Plugin History' &&
              list.memberId === userDetail.userInfo.memberId && (
                <div>
                  <Dropdown
                    toggleElement={
                      <ThreeDotsIcon className="three-dots-icon" />
                    }
                  >
                    <div className="other-updates-dropdown">
                      <p
                        onClick={e => renameLeadsList(e, list.name)}
                        aria-hidden="true"
                      >
                        Rename List
                      </p>
                      <p
                        onClick={e => deleteLeadsList(e, list.name)}
                        aria-hidden="true"
                      >
                        Delete List
                      </p>
                    </div>
                  </Dropdown>
                </div>
              )}
          </div>
        </div>

        {archivedCount > 0 && (
          <div className="archived-count-wrapper">
            <ArchivedIcon className="archived-icon" />
            Archived Contacts:
            <span className="archived-count">
              {Utils.usNumberFormat(archivedCount)}
            </span>
            <div className="info-wrapper">
              <InfoIcon className="info-icon" />
              <InfoDropDownWithImg
                title="Contacts Archived"
                imageComponent={archivedCountInfoImg}
                descriptionContent={description}
                wrapperClassName="archived-count-info-wrapper"
                wrapperMaskClassName=""
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
});

export default ListPageHeader;
